import { useCallback, useRef, useState } from 'react';
import { emptyIntake, validateIntake } from '../lib/intakeValidation';
import { buildIntakePayload, updateIntakeValue } from '../lib/intakeState';
import { useRequestSubmission } from './useRequestSubmission';

export function useIntakeForm(onSaved) {
  const [values, setValues] = useState(emptyIntake);
  const [errors, setErrors] = useState({});
  const form = useRef(null);
  const { busy, error, submit: send, clearError } = useRequestSubmission('/intakes', onSaved);
  const update = useCallback((name, value) => {
    setValues(current => updateIntakeValue(current, name, value));
    setErrors(current => ({ ...current, [name]: undefined }));
  }, []);
  const field = name => ({ value: values[name], onChange: event => update(name, event.target.value), disabled: busy, error: errors[name] });
  const choice = name => ({ ...field(name), onChange: value => update(name, value) });
  const submit = async event => {
    event.preventDefault();
    const invalid = validateIntake(values);
    if (form.current.elements.nextCourtDate?.validity.badInput) invalid.nextCourtDate = 'Please enter a complete, valid court date or leave it blank.';
    setErrors(invalid); clearError();
    const firstInvalid = Object.keys(invalid)[0];
    if (firstInvalid) { form.current.querySelector(`[name="${firstInvalid}"]`)?.focus(); return; }
    await send(buildIntakePayload(values));
  };
  return { values, busy, error, form, update, field, choice, submit };
}